import * as React from 'react'
import { connect } from 'react-redux'
import { Config } from '@chegg-wt/core/config'
import { DashboardUpsellCopy } from '@chegg-wt/core/types/features'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { Dispatch } from 'redux'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import {
  EC_UPSELL,
  EC_UPSELL_ITEM,
  EC_CHECK_CTA,
  EC_UPSELL_HEADING,
} from './utils/testIds'
import {
  ECContainer,
  CTAButton,
  ECHeading,
  ECContent,
  FeatureListContainer,
} from './styles'
import { FeaturePanelDispatchProps } from './types'
import { FeatureItem } from './common'
import * as DomIds from './domIds'

interface ECPanelProps extends FeaturePanelDispatchProps {
  upsellCopy: DashboardUpsellCopy
}

const ECPanel: React.FC<ECPanelProps> = ({ upsellCopy, onUserClick }) => {
  const { FEATURE_LIST, UPSELL_HEADING, CTA_COPY } = upsellCopy.expertCheck
  const features = FEATURE_LIST.map((text, index) => {
    return (
      <FeatureItem key={text} featureText={text} testId={`${EC_UPSELL_ITEM}_${index}`} />
    )
  })
  const handleCTAClick = () => {
    onUserClick()
  }
  return (
    <ECContent id={DomIds.ExpertCheckPanelId}>
      <ECContainer data-test={EC_UPSELL}>
        <ECHeading data-test={EC_UPSELL_HEADING}>{UPSELL_HEADING}</ECHeading>
        <FeatureListContainer>{features}</FeatureListContainer>
        <CTAButton
          size="medium"
          href={Config.expertCheckUrl}
          data-test={EC_CHECK_CTA}
          aria-label={CTA_COPY}
          onClick={handleCTAClick}
        >
          {CTA_COPY}
        </CTAButton>
      </ECContainer>
    </ECContent>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onUserClick: () => dispatch(userClick({ origin: origins.dashboardClickECCTA })),
})

export default connect<{}, FeaturePanelDispatchProps>(null, mapDispatchToProps)(ECPanel)
